// Destino do "Ver como funciona" da tela de Metas. Decisao dela em 07/10: o
// botao existe desde ja, e leva para este aviso ate o tutorial ficar pronto.
export default function EmAndamento() {
  return (
    <section className="p-4">
      <div className="bg-white rounded-2xl shadow-sm p-6 text-center space-y-2">
        <h2 className="text-lg font-bold text-slate-800">Em andamento</h2>
        <p className="text-sm text-slate-500">
          O passo a passo de como funcionam as metas está sendo preparado.
        </p>
      </div>
    </section>
  )
}
